(() => {
  if (!customElements.get('sf-footer-column')) {
    customElements.define('sf-footer-column',class extends HTMLElement {
      connectedCallback() {
        this.details=this.querySelector('details');
        if(!this.details)return;
        this.abort=new AbortController();
        this.media=matchMedia('(max-width:749px)');
        const adapt=()=>{this.details.open=!this.media.matches;};
        adapt();
        this.media.addEventListener('change',adapt,{signal:this.abort.signal});
        this.querySelector('summary').addEventListener('click',e=>{if(!this.media.matches)e.preventDefault();},{signal:this.abort.signal});
      }
      disconnectedCallback(){this.abort?.abort();}
    });
  }
  document.addEventListener('click', e => {
    const button=e.target.closest('[data-sf-search-toggle]');
    if(!button) return;
    const header=button.closest('.sf-header');
    const open=button.getAttribute('aria-expanded')!=='true';
    button.setAttribute('aria-expanded',String(open));
    header.classList.toggle('sf-search-open',open);
    if(open) header.querySelector('input[type="search"]')?.focus();
  });
  if (customElements.get('sf-carousel')) return;
  class StorefrontCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-sf-track]');
      if (!this.track) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.dots = this.querySelector('[data-sf-dots]');
      this.prev = this.querySelector('[data-sf-prev]');
      this.next = this.querySelector('[data-sf-next]');
      this.prev?.addEventListener('click', () => this.move(-1), { signal });
      this.next?.addEventListener('click', () => this.move(1), { signal });
      this.track.addEventListener('scroll', () => this.update(), { passive:true, signal });
      this.addEventListener('keydown', e => {
        if (!['ArrowLeft','ArrowRight'].includes(e.key) || /INPUT|TEXTAREA|SELECT/.test(e.target.tagName)) return;
        e.preventDefault(); this.move(e.key === 'ArrowRight' ? 1 : -1);
      }, { signal });
      this.addEventListener('pointerenter', () => this.stop(), { signal });
      this.addEventListener('pointerleave', () => this.start(), { signal });
      this.addEventListener('focusin', () => this.stop(), { signal });
      this.addEventListener('focusout', () => this.start(), { signal });
      document.addEventListener('visibilitychange', () => document.hidden ? this.stop() : this.start(), { signal });
      document.addEventListener('shopify:block:select', e => {
        const item = e.target.closest('[data-sf-item]');
        if (item && this.contains(item)) { this.stop(); this.track.scrollTo({left:item.offsetLeft-this.track.offsetLeft,behavior:'instant'}); }
      }, { signal });
      this.observer = new ResizeObserver(() => this.layout());
      this.observer.observe(this.track);
      this.layout(); this.start();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.stop(); }
    layout() {
      const items = [...this.track.children];
      if (!items.length) return;
      const step = items.length > 1 ? items[1].offsetLeft-items[0].offsetLeft : items[0].offsetWidth;
      this.step = step || this.track.clientWidth;
      this.visible = Math.max(1, Math.floor((this.track.clientWidth+2)/this.step));
      this.pageWidth = this.step*this.visible;
      this.maxScroll = Math.max(0, this.track.scrollWidth-this.track.clientWidth);
      this.pages = Math.max(1, Math.ceil(this.maxScroll/this.pageWidth)+1);
      const disabled = this.maxScroll < 5;
      if(this.prev) this.prev.hidden = disabled;
      if(this.next) this.next.hidden = disabled;
      if(this.dots) {
        this.dots.hidden = disabled;
        if(this.dots.children.length !== this.pages) {
          this.dots.replaceChildren(...Array.from({length:this.pages},(_,i) => {
            const b = document.createElement('button'); b.type='button'; b.className='sf-dot';
            b.setAttribute('aria-label',`Ir para o grupo ${i+1}`);
            b.addEventListener('click',()=>this.go(i),{signal:this.abort.signal}); return b;
          }));
        }
      }
      this.update();
    }
    update() {
      const x=this.track.scrollLeft;
      this.page=x >= this.maxScroll-3 ? this.pages-1 : Math.round(x/this.pageWidth);
      this.dots && [...this.dots.children].forEach((b,i)=>b.setAttribute('aria-current',String(i===this.page)));
      if(this.prev) this.prev.disabled=x<3;
      if(this.next) this.next.disabled=x>=this.maxScroll-3;
    }
    go(i) { this.track.scrollTo({left:Math.min(this.maxScroll,Math.max(0,i)*this.pageWidth),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}); }
    move(direction) { this.go((this.page||0)+direction); }
    stop() { clearInterval(this.timer); this.timer=null; }
    start() {
      this.stop();
      const seconds=Number(this.dataset.autoplay||0);
      if(!seconds || document.hidden || window.Shopify?.designMode || this.contains(document.activeElement) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.timer=setInterval(()=>this.go((this.page||0)>=this.pages-1 ? 0 : (this.page||0)+1),seconds*1000);
    }
  }
  customElements.define('sf-carousel',StorefrontCarousel);
})();
